<template>
  <div class="event-wrapper">
    <div class="event animate__animated animate__fadeIn" v-if="event">
      <img class="event-image" :src="event.image.path" alt="event-image">
      <div class="event-text">
        <div class="event-title-wrapper">
          <div class="event-title">
            {{ event.name }}
          </div>
          <div class="event-details">
            {{ getDateFromString }} в {{ getTimeFromString }}
          </div>
        </div>
        <div class="event-description">
          {{ event.description }}
        </div>
        <div class="event-button-wrapper">
          <div class="event-price" v-if="!event.price">
            Бронирование
          </div>
          <div class="event-price" v-if="event.price !== 0">
            Вход - {{ event.price + getCurrency }}
          </div>
          <div class="event-price" v-if="event.price === 0">
            Бесплатно
          </div>
          <custom-button
            buttonType="apply"
            :isBlocked="false"
            buttonText="Регистрация"
            @clicked="openEventBooking"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from './Inputs/CustomButton.vue'
import axios from 'axios'
import moment from 'moment'
import InfoLabel from './InfoLabel.vue'
import apiClient from "../../apiClient";

export default {
  components: {InfoLabel, CustomButton},
  name: 'EventPage',
  props: ['eventId'],
  computed: {
    getDateFromString () {
      return moment(this.event.startDate, 'YYYY-MM-DD HH:mm').locale('ru').format('DD MMM yyyy')
    },
    getTimeFromString () {
      return moment(this.event.startDate, 'YYYY-MM-DD HH:mm').format('HH:mm')
    },
    getCurrency() {
      return this.$store.state.adminProperties && this.$store.state.adminProperties.currency ? this.$store.state.adminProperties.currency.symbol : ""
    }
  },
  data () {
    return {
      event: null,
      imgPath: '',
      price: 0,
      hallType: 0,
      openEventBooking: 0
    }
  },
  created: function () {
    let that = this

    apiClient.get('/api/event/detail', {
      params: {
        eventId: this.eventId
      }
    }).then(function (response) {
      that.event = response.data
    })
  }
}
</script>

<style scoped>
.event-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.event {
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  border: 1px solid #D0D5DD;
  background: #FFF;
  box-shadow: 0 8px 8px -4px rgba(16, 24, 40, 0.03), 0 20px 24px -4px rgba(16, 24, 40, 0.08);
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  width: 60%;
  max-height: 350px;
  transition: .2s;
}

.event-image {
  height: 100%;
  max-height: 350px;
  border-radius: 12px 0 0 12px;
  width: 50%;
}

.event-text {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 24px 24px 60px;
  width: 100%;
}

.event-title-wrapper {
  display: flex;
  justify-content: space-between;
}

.event-title {
  color: #101828;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
}

.event-details {
  color: #101828;
  font-size: 14px;
  font-weight: 300;
  line-height: 28px; /* 200% */
}

.event-description {
  color: #101828;
  text-overflow: ellipsis;
  font-size: 12px;
  flex-grow: 1;
  font-weight: 400;
}

.event-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  height: 35px;
}

.event-price {
  width: 100%;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
}
</style>



// WEBPACK FOOTER //
// src/components/client/EventPage.vue